/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Comment_Field_Emergency_HelpInputs */

const en_comment_field_emergency_help = /** @type {(inputs: Comment_Field_Emergency_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marks this note as high priority for the service desk.`)
};

const ja_comment_field_emergency_help = /** @type {(inputs: Comment_Field_Emergency_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このメモをサービスデスクにとって高優先度として記録します。`)
};

const fr_comment_field_emergency_help = /** @type {(inputs: Comment_Field_Emergency_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque cette note comme haute priorité pour le service desk.`)
};

const de_comment_field_emergency_help = /** @type {(inputs: Comment_Field_Emergency_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markiert diese Notiz als hohe Priorität für den Service Desk.`)
};

/**
* | output |
* | --- |
* | "Marks this note as high priority for the service desk." |
*
* @param {Comment_Field_Emergency_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const comment_field_emergency_help = /** @type {((inputs?: Comment_Field_Emergency_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Comment_Field_Emergency_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_comment_field_emergency_help(inputs)
	if (locale === "ja") return ja_comment_field_emergency_help(inputs)
	if (locale === "fr") return fr_comment_field_emergency_help(inputs)
	return de_comment_field_emergency_help(inputs)
});